import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext.js";

const normalizeRole = (user) => String(user?.role || "").toLowerCase();

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return null;
  }

  if (status !== "authenticated") {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles?.length && !allowedRoles.includes(normalizeRole(user))) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
